const canariaIslandId = 108011;

export const shouldShowRegion = (id) => {
  if (id === canariaIslandId) return true;
  return false;
};
